import React from 'react';

export const Requests = () => <h3>This is requests</h3>;
